module.exports = __webpack_public_path__ + "img/ia-02-1.387e7da7.jpg";